// extracted by mini-css-extract-plugin
export default {"jobItem":"Experience_jobItem__RbG61"};